import SortOrder from "../../enum/SortOrder";

export type Comparator<T> = (a: T, b: T) => number;

const applyOrder = <T>(comparator: Comparator<T>, order: SortOrder): Comparator<T> => {
  const sign = order === SortOrder.ASC ? 1 : -1;
  return (a: T, b: T) => sign * comparator(a, b);
};

export default applyOrder;
